import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-50 overflow-y-auto"
}
const _hoisted_2 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_3 = { class: "inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-4xl sm:w-full" }
const _hoisted_4 = { class: "bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4" }
const _hoisted_5 = { class: "flex justify-between items-start" }
const _hoisted_6 = { class: "text-xl font-bold text-gray-900" }
const _hoisted_7 = { class: "text-sm text-gray-500 mt-1" }
const _hoisted_8 = { class: "mt-6 grid grid-cols-1 md:grid-cols-2 gap-6" }
const _hoisted_9 = { class: "space-y-2" }
const _hoisted_10 = { class: "flex justify-between" }
const _hoisted_11 = { class: "flex justify-between" }
const _hoisted_12 = { class: "flex justify-between" }
const _hoisted_13 = { class: "bg-blue-600 text-white text-xs px-2 py-1 rounded-full" }
const _hoisted_14 = {
  key: 0,
  class: "space-y-2"
}
const _hoisted_15 = { class: "flex items-center justify-between" }
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "flex items-center mt-2" }
const _hoisted_18 = {
  key: 0,
  class: "h-10 w-10 rounded-full flex-shrink-0 overflow-hidden"
}
const _hoisted_19 = ["src"]
const _hoisted_20 = {
  key: 1,
  class: "h-10 w-10 rounded-full bg-gray-200 flex-shrink-0 flex items-center justify-center"
}
const _hoisted_21 = { class: "text-gray-500 text-sm font-medium" }
const _hoisted_22 = { class: "ml-3" }
const _hoisted_23 = { class: "font-medium" }
const _hoisted_24 = { class: "text-sm text-gray-500" }
const _hoisted_25 = {
  key: 1,
  class: "flex items-center"
}
const _hoisted_26 = {
  key: 0,
  class: "h-10 w-10 rounded-full flex-shrink-0 overflow-hidden"
}
const _hoisted_27 = ["src"]
const _hoisted_28 = {
  key: 1,
  class: "h-10 w-10 rounded-full bg-gray-200 flex-shrink-0 flex items-center justify-center"
}
const _hoisted_29 = { class: "text-gray-500 text-sm font-medium" }
const _hoisted_30 = { class: "ml-3" }
const _hoisted_31 = { class: "font-medium" }
const _hoisted_32 = { class: "mt-8" }
const _hoisted_33 = { class: "flex justify-between items-center mb-4" }
const _hoisted_34 = { class: "flex items-center" }
const _hoisted_35 = {
  key: 0,
  class: "flex justify-center items-center py-8"
}
const _hoisted_36 = {
  key: 1,
  class: "py-6"
}
const _hoisted_37 = { class: "grid grid-cols-1 gap-4" }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { class: "font-medium text-blue-600" }
const _hoisted_40 = { class: "text-sm text-gray-500 mt-1" }
const _hoisted_41 = {
  key: 2,
  class: "bg-red-50 border-l-4 border-red-500 p-4 mb-4"
}
const _hoisted_42 = { class: "flex" }
const _hoisted_43 = { class: "ml-3" }
const _hoisted_44 = { class: "text-sm text-red-700" }
const _hoisted_45 = ["readonly"]
const _hoisted_46 = ["readonly"]
const _hoisted_47 = ["readonly"]
const _hoisted_48 = {
  key: 0,
  class: "border border-gray-300 rounded-t-md bg-gray-50 p-2 flex flex-wrap gap-1"
}
const _hoisted_49 = ["innerHTML"]
const _hoisted_50 = { class: "mt-4" }
const _hoisted_51 = { class: "flex flex-col space-y-2" }
const _hoisted_52 = { class: "flex items-center" }
const _hoisted_53 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_54 = { class: "flex items-center" }
const _hoisted_55 = { class: "text-sm truncate max-w-xs" }
const _hoisted_56 = ["onClick"]
const _hoisted_57 = { class: "bg-gray-50 px-4 py-3 sm:px-6 flex justify-between" }
const _hoisted_58 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "fixed inset-0 transition-opacity",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
          }, _cache[15] || (_cache[15] = [
            _createElementVNode("div", { class: "absolute inset-0 bg-gray-500 opacity-75" }, null, -1)
          ])),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", null, [
                  _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.getDocumentName() || 'Revenue Forecast Template'), 1),
                  _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.getDocumentDescription() || 'Template for forecasting and planning purposes'), 1)
                ]),
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
                  class: "text-gray-400 hover:text-gray-500"
                }, _cache[16] || (_cache[16] = [
                  _createElementVNode("svg", {
                    class: "h-6 w-6",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M6 18L18 6M6 6l12 12"
                    })
                  ], -1)
                ]))
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _cache[17] || (_cache[17] = _createElementVNode("span", { class: "text-gray-500" }, "Document:", -1)),
                      _createElementVNode("span", null, _toDisplayString(_ctx.getDocumentName()), 1)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _cache[18] || (_cache[18] = _createElementVNode("span", { class: "text-gray-500" }, "Process:", -1)),
                      _createElementVNode("span", null, _toDisplayString(_ctx.getProcessName()), 1)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _cache[19] || (_cache[19] = _createElementVNode("span", { class: "text-gray-500" }, "Status:", -1)),
                      _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.getDocumentStatus()), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  (_ctx.hasPlanners)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _cache[20] || (_cache[20] = _createElementVNode("span", { class: "text-gray-500" }, "Assigned Planner:", -1)),
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedPlannerId) = $event)),
                            onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handlePlannerChange && _ctx.handlePlannerChange(...args))),
                            class: "bg-white border border-gray-300 text-gray-700 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 p-1.5"
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.planners, (planner) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: planner.id,
                                value: planner.id
                              }, _toDisplayString(planner.name || planner.email), 9, _hoisted_16))
                            }), 128))
                          ], 544), [
                            [_vModelSelect, _ctx.selectedPlannerId]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          (_ctx.getPlannerAvatarUrl())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                _createElementVNode("img", {
                                  src: _ctx.getPlannerAvatarUrl(),
                                  alt: "Planner Avatar",
                                  class: "w-full h-full object-cover"
                                }, null, 8, _hoisted_19)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.getPlannerInitial()), 1)
                              ])),
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.getPlannerName()), 1),
                            _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.getSelectedPlannerEmail()), 1)
                          ])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        (_ctx.getPlannerAvatarUrl())
                          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                              _createElementVNode("img", {
                                src: _ctx.getPlannerAvatarUrl(),
                                alt: "Planner Avatar",
                                class: "w-full h-full object-cover"
                              }, null, 8, _hoisted_27)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                              _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.getPlannerInitial()), 1)
                            ])),
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.getPlannerName()), 1),
                          _cache[21] || (_cache[21] = _createElementVNode("p", { class: "text-sm text-gray-500" }, "Assigned Planner", -1))
                        ])
                      ]))
                ])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _cache[22] || (_cache[22] = _createElementVNode("h4", { class: "font-medium" }, "Email Template Preview", -1)),
                    _createElementVNode("span", {
                      class: _normalizeClass(["ml-2 text-xs px-2 py-0.5 rounded-full", _ctx.isEditMode ? 'bg-blue-100 text-blue-800' : 'bg-gray-100 text-gray-800'])
                    }, _toDisplayString(_ctx.isEditMode ? 'Editable' : 'Read-only'), 3)
                  ]),
                  _createElementVNode("button", {
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleEditMode && _ctx.toggleEditMode(...args))),
                    class: _normalizeClass(["text-sm px-3 py-1 rounded-md border", _ctx.isEditMode
                  ? 'border-red-300 bg-red-50 text-red-700 hover:bg-red-100'
                  : 'border-blue-300 bg-blue-50 text-blue-700 hover:bg-blue-100'])
                  }, _toDisplayString(_ctx.isEditMode ? 'Disable Editing' : 'Enable Editing'), 3)
                ]),
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, _cache[23] || (_cache[23] = [
                      _createElementVNode("div", { class: "animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" }, null, -1),
                      _createElementVNode("span", { class: "ml-2" }, "Loading template...", -1)
                    ])))
                  : (_ctx.showTemplateSelection)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                        _cache[24] || (_cache[24] = _createElementVNode("h3", { class: "text-lg font-medium text-gray-900 mb-4" }, "Select Email Template", -1)),
                        _createElementVNode("div", _hoisted_37, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableTemplates, (template) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: template.email_template_id,
                              class: "border border-gray-200 rounded-lg p-4 hover:bg-blue-50 cursor-pointer transition-colors",
                              onClick: ($event: any) => (_ctx.selectTemplate(template.email_template_id))
                            }, [
                              _createElementVNode("h4", _hoisted_39, _toDisplayString(template.template_name), 1),
                              _createElementVNode("p", _hoisted_40, _toDisplayString(template.subject), 1)
                            ], 8, _hoisted_38))
                          }), 128))
                        ])
                      ]))
                    : (_ctx.errorMessage)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                          _createElementVNode("div", _hoisted_42, [
                            _cache[25] || (_cache[25] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                              _createElementVNode("svg", {
                                class: "h-5 w-5 text-red-500",
                                viewBox: "0 0 20 20",
                                fill: "currentColor"
                              }, [
                                _createElementVNode("path", {
                                  "fill-rule": "evenodd",
                                  d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
                                  "clip-rule": "evenodd"
                                })
                              ])
                            ], -1)),
                            _createElementVNode("div", _hoisted_43, [
                              _createElementVNode("p", _hoisted_44, _toDisplayString(_ctx.errorMessage), 1)
                            ])
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 3,
                          class: _normalizeClass(["space-y-4 bg-white border-2 rounded-md p-4 transition-colors duration-200", _ctx.isEditMode ? 'border-blue-300' : 'border-gray-200'])
                        }, [
                          _createElementVNode("div", null, [
                            _cache[26] || (_cache[26] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, "To", -1)),
                            _withDirectives(_createElementVNode("input", {
                              type: "email",
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.emailData.to) = $event)),
                              class: _normalizeClass([
                    'w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none',
                    _ctx.isEditMode
                      ? 'border-blue-300 focus:ring-blue-500 focus:border-blue-500 bg-white'
                      : 'border-gray-200 bg-gray-50 cursor-default'
                  ]),
                              readonly: !_ctx.isEditMode
                            }, null, 10, _hoisted_45), [
                              [_vModelText, _ctx.emailData.to]
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _cache[27] || (_cache[27] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, "CC", -1)),
                            _withDirectives(_createElementVNode("input", {
                              type: "email",
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.emailData.cc) = $event)),
                              placeholder: "Comma-separated email addresses",
                              class: _normalizeClass([
                    'w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none',
                    _ctx.isEditMode
                      ? 'border-blue-300 focus:ring-blue-500 focus:border-blue-500 bg-white'
                      : 'border-gray-200 bg-gray-50 cursor-default'
                  ]),
                              readonly: !_ctx.isEditMode
                            }, null, 10, _hoisted_46), [
                              [_vModelText, _ctx.emailData.cc]
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _cache[28] || (_cache[28] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, "Subject", -1)),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.emailData.subject) = $event)),
                              class: _normalizeClass([
                    'w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none',
                    _ctx.isEditMode
                      ? 'border-blue-300 focus:ring-blue-500 focus:border-blue-500 bg-white'
                      : 'border-gray-200 bg-gray-50 cursor-default'
                  ]),
                              readonly: !_ctx.isEditMode
                            }, null, 10, _hoisted_47), [
                              [_vModelText, _ctx.emailData.subject]
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _cache[32] || (_cache[32] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, "Message", -1)),
                            (_ctx.isEditMode)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                  _createElementVNode("button", {
                                    onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.applyFormatting('bold')), ["prevent"])),
                                    class: "p-1 rounded hover:bg-gray-200 w-7 h-7 flex items-center justify-center",
                                    title: "Bold"
                                  }, _cache[29] || (_cache[29] = [
                                    _createElementVNode("span", { class: "font-bold text-lg" }, "B", -1)
                                  ])),
                                  _createElementVNode("button", {
                                    onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.applyFormatting('italic')), ["prevent"])),
                                    class: "p-1 rounded hover:bg-gray-200 w-7 h-7 flex items-center justify-center",
                                    title: "Italic"
                                  }, _cache[30] || (_cache[30] = [
                                    _createElementVNode("span", { class: "italic text-lg" }, "i", -1)
                                  ])),
                                  _createElementVNode("button", {
                                    onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.applyFormatting('underline')), ["prevent"])),
                                    class: "p-1 rounded hover:bg-gray-200 w-7 h-7 flex items-center justify-center",
                                    title: "Underline"
                                  }, _cache[31] || (_cache[31] = [
                                    _createElementVNode("span", { class: "underline text-lg" }, "U", -1)
                                  ]))
                                ]))
                              : _createCommentVNode("", true),
                            (!_ctx.isEditMode)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 1,
                                  class: "prose max-w-none w-full px-3 py-2 border rounded-md shadow-sm overflow-auto border-gray-200 bg-gray-50 cursor-default h-64",
                                  innerHTML: _ctx.sanitizedMessageHtml
                                }, null, 8, _hoisted_49))
                              : (_openBlock(), _createElementBlock("div", {
                                  key: 2,
                                  id: "email-content-editor",
                                  contenteditable: "true",
                                  onInput: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.updateEmailContent && _ctx.updateEmailContent(...args))),
                                  class: "w-full min-h-[250px] px-3 py-2 border border-gray-300 rounded-b-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
                                }, null, 32))
                          ]),
                          _createElementVNode("div", _hoisted_50, [
                            _cache[36] || (_cache[36] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, "Attachments", -1)),
                            _createElementVNode("div", _hoisted_51, [
                              _createElementVNode("div", _hoisted_52, [
                                _createElementVNode("input", {
                                  type: "file",
                                  id: "file-attachment",
                                  onChange: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.handleFileAttachment && _ctx.handleFileAttachment(...args))),
                                  class: "hidden"
                                }, null, 32),
                                _cache[33] || (_cache[33] = _createElementVNode("label", {
                                  for: "file-attachment",
                                  class: "px-3 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 cursor-pointer flex items-center"
                                }, [
                                  _createElementVNode("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    class: "h-5 w-5 mr-2",
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    stroke: "currentColor"
                                  }, [
                                    _createElementVNode("path", {
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                      "stroke-width": "2",
                                      d: "M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"
                                    })
                                  ]),
                                  _createTextVNode(" Add Attachment ")
                                ], -1))
                              ]),
                              (_ctx.attachments.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attachments, (attachment, index) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: index,
                                        class: "flex items-center justify-between bg-gray-50 p-2 rounded-md mb-1"
                                      }, [
                                        _createElementVNode("div", _hoisted_54, [
                                          _cache[34] || (_cache[34] = _createElementVNode("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            class: "h-5 w-5 text-gray-500 mr-2",
                                            fill: "none",
                                            viewBox: "0 0 24 24",
                                            stroke: "currentColor"
                                          }, [
                                            _createElementVNode("path", {
                                              "stroke-linecap": "round",
                                              "stroke-linejoin": "round",
                                              "stroke-width": "2",
                                              d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                                            })
                                          ], -1)),
                                          _createElementVNode("span", _hoisted_55, _toDisplayString(attachment.filename), 1)
                                        ]),
                                        _createElementVNode("button", {
                                          onClick: ($event: any) => (_ctx.removeAttachment(index)),
                                          class: "text-red-500 hover:text-red-700",
                                          title: "Remove attachment"
                                        }, _cache[35] || (_cache[35] = [
                                          _createElementVNode("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            class: "h-5 w-5",
                                            fill: "none",
                                            viewBox: "0 0 24 24",
                                            stroke: "currentColor"
                                          }, [
                                            _createElementVNode("path", {
                                              "stroke-linecap": "round",
                                              "stroke-linejoin": "round",
                                              "stroke-width": "2",
                                              d: "M6 18L18 6M6 6l12 12"
                                            })
                                          ], -1)
                                        ]), 8, _hoisted_56)
                                      ]))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ], 2))
              ])
            ]),
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.navigateToEditTemplate && _ctx.navigateToEditTemplate(...args))),
                  class: "inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm"
                }, " Edit Template ")
              ]),
              _createElementVNode("button", {
                onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.sendEmail && _ctx.sendEmail(...args))),
                disabled: _ctx.isLoading,
                class: "inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:text-sm disabled:opacity-50 disabled:cursor-not-allowed"
              }, _toDisplayString(_ctx.isLoading ? 'Sending...' : 'Send Email'), 9, _hoisted_58)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}